"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var ignoreElements_1 = require("../../operator/ignoreElements");
rxjs_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs-compat/add/operator/ignoreElements.js
// module id = 517
// module chunks = 0